/* Suzy Clue — scroll reveals (respects reduced motion) */
(function(){
  if (window.__szInit) return; window.__szInit = 1;
  var reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  function arm(){
    var els = document.querySelectorAll('.sz-r:not(.in)');
    if (reduce || !('IntersectionObserver' in window)) { els.forEach(function(e){e.classList.add('in')}); return; }
    var io = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target);} });
    }, {rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){ io.observe(e); });
  }
  function loadVideo(v){
    if (!v.dataset.src) return;
    v.src = v.dataset.src;
    v.removeAttribute('data-src');
    v.load();
    var p = v.play();
    if (p && p.catch) p.catch(function(){});
  }
  function vids(){
    var list = document.querySelectorAll('video[data-src]');
    if (!list.length) return;
    if (!('IntersectionObserver' in window)) { list.forEach(loadVideo); return; }
    var vio = new IntersectionObserver(function(es){
      es.forEach(function(en){ if(en.isIntersecting){ loadVideo(en.target); vio.unobserve(en.target); } });
    }, {rootMargin:'1200px 0px'});
    list.forEach(function(v){ vio.observe(v); });
  }
  function init(){ arm(); vids(); }
  document.readyState === 'loading' ? addEventListener('DOMContentLoaded', init) : init();
  document.addEventListener('shopify:section:load', init);

  /* Resilience: DOM morphs (cart updates, dev hot-reload, editor) replace
     nodes after arm() ran, leaving .sz-r elements permanently invisible.
     Re-arm on any DOM change, and run a failsafe sweep that reveals
     anything sitting in the viewport that the observer missed. */
  function sweep(){
    document.querySelectorAll('.sz-r:not(.in)').forEach(function(el){
      var r = el.getBoundingClientRect();
      if (r.top < innerHeight + 40 && r.bottom > -40) el.classList.add('in');
    });
  }
  if ('MutationObserver' in window) {
    var pending = null;
    new MutationObserver(function(){
      if (pending) return;
      pending = setTimeout(function(){ pending = null; init(); sweep(); }, 120);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
  addEventListener('scroll', function(){ sweep(); }, { passive: true });
  setTimeout(sweep, 900);
  setTimeout(sweep, 2500);
})();

/* Suzy Clue — size-aware quick add (shop grid).
   Chips set the form's variant id; the add button stays
   disabled until a size is deliberately chosen. */
(function () {
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.sz-size');
    if (!chip || chip.disabled) return;
    var form = chip.closest('form');
    if (!form) return;
    form.querySelectorAll('.sz-size').forEach(function (b) {
      b.classList.remove('on');
      b.setAttribute('aria-pressed', 'false');
    });
    chip.classList.add('on');
    chip.setAttribute('aria-pressed', 'true');
    var input = form.querySelector('input[name="id"]');
    if (input) { input.value = chip.dataset.variantId; input.disabled = false; }
    var btn = form.querySelector('button[data-needs-size]');
    if (btn) { btn.disabled = false; btn.textContent = btn.dataset.label || 'Add to cart'; }
  });
})();
